import { render } from "./OvApplicationCheckboxes.vue?vue&type=template&id=683a90d0&scoped=true"
import script from "./OvApplicationCheckboxes.vue?vue&type=script&lang=js"
export * from "./OvApplicationCheckboxes.vue?vue&type=script&lang=js"

import "./OvApplicationCheckboxes.vue?vue&type=style&index=0&id=683a90d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683a90d0"]])

export default __exports__